import { faBars, faBrush, faHandPointUp, faMoon, faPrint } from "@fortawesome/free-solid-svg-icons";
import SoftwareFragment from "../fragments/SoftwareFragment";

const JotSpotmacOS = () => {
  return (
    <SoftwareFragment
      appName={"JotSpot macOS"}
      appIcon={"./images/JotSpotmacOS/icon.png"}
      appLink={
        "https://geo.itunes.apple.com/us/app/jotspot-simple-word-processor/id1022477396?mt=12&at=10lNVd"
      }
      subTitle={
        "Simple, Functional, And Beautifully Designed Text Editor And Notepad"
      }
      description={
        "JotSpot is an amazing app that lets you jot down some quick notes, ideas, shopping lists, and more. Then when you're done print out a final copy. JotSpot features things like Dark Mode for writing at night, a simple and clean interface, amazing support, and much, much more. "
      }
      images={[
        "./images/JotSpotmacOS/JotSpot 1.png",
        "./images/JotSpotmacOS/JotSpot 2.png",
        "./images/JotSpotmacOS/JotSpot 3.png",
        "./images/JotSpotmacOS/JotSpot 4.png",
      ]}
      features={[
        {
          title: "Dark Mode",
          description:
            "Both the macOS and iOS versions feature Dark Mode for writing at night.",
          icon: faMoon,
        },
        {
          title: "Rich Text Editing",
          description:
            "Rich text editing allows for more than just plain text. You can change font colors, sizes, and more.",
          icon: faBrush,
        },
        {
          title: "Print",
          description:
            "Print your notes with ease, ensuring you never lose important information.",
          icon: faPrint,
        },
      ]}
      price={"$0.99"}
      supportedVersion={"macOS 10.10+"}
      size={"5 MB"}
    />
  );
};

export default JotSpotmacOS;
